import { EmailOTPScreen } from '@/modules/onboarding/verification/otp';
import React from 'react';

export default function EmailOTPPage() {
    return <EmailOTPScreen />;
}